export type SupportedLanguage = {
  code: string;
  label: string;
};
